/* global google */
import $ from 'jquery'
import {Loader} from '@googlemaps/js-api-loader'
import BccSharedCockpitFrontend from "bcc-shared-cockpit";

export default class googleMapsHeatmap {
    constructor(element) {
        this.$element = $(element)
        this.$map = this.$element.find('.map')
        this.$noMap = this.$element.find('.noMap')
        this.$allowTracking = this.$noMap.find('a.allowTracking')
        this.$customTools = this.$element.find('.customTools')
        this.gooleApiKey = this.$element.data('apiKey')

        const mapsConfig = this.$element.data('mapsConfig')
        this.mapConfig = {
            lat: mapsConfig.lat,
            lng: mapsConfig.lng,
            address: mapsConfig.address,
            zoom: mapsConfig.zoom,
            title: mapsConfig.title,
            description: mapsConfig.description,
            zoomControl: mapsConfig.zoomControl,
            scaleControl: mapsConfig.scaleControl,
            mapTypeControl: mapsConfig.mapTypeControl,
            fullscreenControl: mapsConfig.fullscreenControl,
            autoOpenLocationInfo: mapsConfig.autoOpenLocationInfo,
            heatmapCoordinates: mapsConfig.heatmapCoordinates,
        }

        this.map = null
        this.markers = []
        this.openedInfoWindow = null

        const Tracking = BccSharedCockpitFrontend.getTracking()
        Tracking.onTrackingAllowed(this.initializeMap.bind(this))
        this.initializeMap()
        // this.$allowTracking.on('click', function (event) {
        //   event.preventDefault()
        //   this.initializeMap()
        // }.bind(this))
    }

    async initializeMap() {
        this.$noMap.hide()

        const loader = new Loader({
            apiKey: this.gooleApiKey,
            version: 'weekly',
            libraries: ['places', 'visualization']
        })

        await loader.importLibrary('maps')
        this.setupMap()
    }

    setupMap() {
        const mapOptions = Object.assign({}, this.mapInit, {
            zoom: this.mapConfig.zoom,
            center: {lat: this.mapConfig.lat, lng: this.mapConfig.lng},
            zoomControl: this.mapConfig.zoomControl,
            scaleControl: this.mapConfig.scaleControl,
            mapTypeControl: this.mapConfig.mapTypeControl,
            clickableIcons: false, // When false, map icons are not clickable. A map icon represents a point of interest, also known as a POI. By default map icons are clickable.
            disableDefaultUI: true, // Enables/disables all default UI buttons. May be overridden individually. Does not disable the keyboard controls, which are separately controlled by the MapOptions.keyboardShortcuts option. Does not disable gesture controls, which are separately controlled by the MapOptions.gestureHandling option.
            fullscreenControl: this.mapConfig.fullscreenControl,
            gestureHandling: 'cooperative',
            mapTypeId: google.maps.MapTypeId.ROADMAP
        })

        this.map = new google.maps.Map(this.$map.get(0), mapOptions)

        /* Data points defined as a mixture of WeightedLocation and LatLng objects */
        let heatmapData = [];
        for (let coordinates of this.mapConfig.heatmapCoordinates) {
            heatmapData.push(
              {location: new google.maps.LatLng(coordinates.lat, coordinates.lng), weight: coordinates.weight}
            )
        }

        //initialize heatmap layer
        var heatmap = new google.maps.visualization.HeatmapLayer({
            data: heatmapData
        });

        // add heatmap layer to map
        heatmap.setMap(this.map);

        // Append the control to the DIV.
        this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(this.$customTools.get(0))

    }

}
